import firebase from "firebase/compat/app";
import "firebase/compat/functions";
import { db } from "services/firebase";
import {
  COLLECTIONS,
  TRANSACTION_PAGE_SIZE,
} from "components/dashboard/zipSlotAds/zipSlotAdsConstants";

function callable(name) {
  return firebase.functions().httpsCallable(name);
}

export async function placeZipSlotBid({
  zip,
  locationId,
  bidPerClickCents,
  institutionId,
}) {
  const fn = callable("placeZipSlotBid");
  const result = await fn({
    zip,
    locationId,
    bidPerClickCents,
    ...(institutionId ? { institutionId } : {}),
  });
  return result.data;
}

export async function topUpBalance({
  amountCents,
  successUrl,
  cancelUrl,
  institutionId,
}) {
  const fn = callable("topUpBalance");
  const result = await fn({
    amountCents,
    successUrl,
    cancelUrl,
    ...(institutionId ? { institutionId } : {}),
  });
  return result.data;
}

export async function updateAdAutoRecharge({
  institutionId,
  autoRechargeEnabled,
  autoRechargeThresholdCents,
  autoRechargeAmountCents,
}) {
  const fn = callable("updateAdAutoRecharge");
  const result = await fn({
    ...(institutionId ? { institutionId } : {}),
    autoRechargeEnabled,
    autoRechargeThresholdCents,
    autoRechargeAmountCents,
  });
  return result.data;
}

export async function getZipSlotRanksForDisplay(zip) {
  if (!zip) return { zip: "", slots: [], updatedAt: null };
  const fn = callable("getZipSlotRanksForDisplay");
  const result = await fn({ zip });
  return result.data;
}

/** Patient-facing ranks for CareMap — institutionId/locationId, no pricing. */
export async function getZipSlotRanksForCareMap(zip) {
  if (!zip) return { zip: "", slots: [], updatedAt: null };
  const fn = callable("getZipSlotRanksForCareMap");
  const result = await fn({ zip });
  return result.data;
}

export async function getUserPaymentMethod() {
  const fn = callable("getUserPaymentMethod");
  const result = await fn();
  return result.data;
}

export function listenAdBalance(institutionId, onNext, onError) {
  if (!institutionId) return () => {};
  return db
    .collection(COLLECTIONS.AD_BALANCES)
    .doc(institutionId)
    .onSnapshot(
      (snap) => {
        onNext(snap.exists ? { id: snap.id, ...snap.data() } : null);
      },
      onError,
    );
}

export function listenOwnZipSlotBid(zip, institutionId, onNext, onError) {
  if (!zip || !institutionId) return () => {};
  return db
    .collection(COLLECTIONS.ZIP_SLOT_BIDS)
    .doc(zip)
    .collection("bids")
    .doc(institutionId)
    .onSnapshot(
      (snap) => {
        onNext(snap.exists ? { id: snap.id, ...snap.data() } : null);
      },
      onError,
    );
}

export async function getOwnZipSlotBid(zip, institutionId) {
  if (!zip || !institutionId) return null;
  const snap = await db
    .collection(COLLECTIONS.ZIP_SLOT_BIDS)
    .doc(zip)
    .collection("bids")
    .doc(institutionId)
    .get();
  return snap.exists ? { id: snap.id, ...snap.data() } : null;
}

export async function listInstitutionLocations(institutionId) {
  if (!institutionId) return [];
  const snap = await db
    .collection("locations")
    .where("institutionId", "==", institutionId)
    .get();
  return snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
}

export async function listLedgerPage({
  institutionId,
  pageSize = TRANSACTION_PAGE_SIZE,
  startAfterDoc = null,
}) {
  if (!institutionId) return { rows: [], lastDoc: null, hasMore: false };

  let query = db
    .collection(COLLECTIONS.AD_BALANCE_TRANSACTIONS)
    .doc(institutionId)
    .collection("entries")
    .orderBy("createdAt", "desc")
    .limit(pageSize);

  if (startAfterDoc) {
    query = query.startAfter(startAfterDoc);
  }

  const snap = await query.get();
  return {
    rows: snap.docs.map((doc) => ({ id: doc.id, ...doc.data(), _doc: doc })),
    lastDoc: snap.docs.length ? snap.docs[snap.docs.length - 1] : null,
    hasMore: snap.docs.length === pageSize,
  };
}
